import { render, staticRenderFns } from "./ViewActivoPublicPage.vue?vue&type=template&id=a960fcfe"
import script from "./ViewActivoPublicPage.vue?vue&type=script&lang=js"
export * from "./ViewActivoPublicPage.vue?vue&type=script&lang=js"
import style0 from "./ViewActivoPublicPage.vue?vue&type=style&index=0&id=a960fcfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports